import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';
import * as DropdownStyles from 'theme/components/Dropdown.style';

export const Backdrop = styled('div')<{ $isOpen: boolean }>`
  background-color: ${colours.neutral[900]};
  bottom: 0;
  left: 0;
  opacity: ${({ $isOpen }) => ($isOpen ? 0.5 : 0)};
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1300;
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
`;

export const Container = styled('div')<{ $isOpen: boolean }>`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1300;
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: ${breakpoints.tablet}) {
    align-items: flex-start;
    padding-top: 16px;
  }
`;

export const Card = styled('div')`
  background-color: white;
  border: 2px solid ${colours.neutral[200]};
  border-radius: 35px;
  box-shadow: 0 50px 70px -35px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  max-width: 600px;
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 1301;

  @media (max-width: ${breakpoints.tablet}) {
    width: calc(100% - 20px);
    margin: 10px;
    max-width: calc(100% - 20px);
  }
`;

export const Header = styled('div')`
  display: flex;
  align-items: start;
  gap: 5px;
  position: sticky;
  top: 0;
  background: white;
  padding: 10px 10px 0;
  z-index: 1;
`;

export const ResultsList = styled('div')`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px;
`;

export const ResultRow = styled(DropdownStyles.ItemButton).attrs({
  $hasSubContent: true,
})<{ $isSelected?: boolean }>`
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  background-color: ${({ $isSelected }) =>
    $isSelected ? colours.neutral[100] : 'transparent'};
`;

export const ResultTitle = styled(Text.P2)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const Highlight = styled('span')`
  background: rgba(255, 214, 102, 0.6);
  border-radius: 4px;
  padding: 0 2px;
`;

export const MetaRow = styled('div')`
  align-items: center;
  display: flex;
  gap: 5px;
`;

export const GroupCard = styled('div')`
  background-color: ${colours.neutral[100]};
  border: 1px solid ${colours.neutral[100]};
  border-radius: 25px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  padding: 5px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  width: 100%;

  &:hover,
  &:focus-visible {
    background-color: ${colours.neutral[200]};
    border-color: ${colours.neutral[200]};
    outline: none;
  }
`;

export const EventBlock = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  width: 100%;
`;

export const EventHeaderRow = styled('div')`
  align-items: flex-start;
  display: flex;
  gap: 5px;
  justify-content: space-between;
  width: 100%;
`;

export const EventTitleGroup = styled('div')`
  align-items: center;
  display: flex;
  flex: 1 1 0;
  gap: 5px;
  min-width: 0;
`;

export const EventTitleText = styled(Text.P1Bold)`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EventDate = styled(Text.Label)`
  color: ${colours.neutral[500]};
  flex-shrink: 0;
  white-space: nowrap;
`;

export const EventSummaryText = styled(Text.P2)`
  color: ${colours.neutral[900]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const NotesList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const NoteBlock = styled('button')`
  background: ${colours.shade[0]};
  border: none;
  border-radius: 20px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: 10px;
  text-align: left;
  width: 100%;

  &:focus {
    outline: none;
  }
`;

export const NoteText = styled(Text.P2)`
  color: ${colours.neutral[900]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const StatusIcon = styled('span')<{ $color: string }>`
  align-items: center;
  color: ${({ $color }) => $color};
  display: flex;
  flex-shrink: 0;
  height: 16px;
  justify-content: center;
  width: 16px;

  svg {
    height: 16px;
    stroke-width: 2;
    width: 16px;
  }
`;
